import { Zap, UserPlus, UserMinus, Building2 } from 'lucide-react'
import LoopPage from '../../components/LoopPage'
import { BETA_CTA_TEXT, EMBED_BETA_HREF } from '../../config/cta'

const stakeholders = [
  { icon: Zap, label: 'Power users', description: 'The people who know your product better than your PM. Mine them for the use cases you did not design for.' },
  { icon: UserPlus, label: 'New users', description: 'The first-week experience. Where they got stuck. What they thought your product did.' },
  { icon: UserMinus, label: 'Lapsed users', description: 'Why they stopped. Whether it was you, them, or the moment. Often the cheapest re-engagement signal.' },
  { icon: Building2, label: 'Internal users', description: 'Your support team, CSMs, and sales. They hear what users say but rarely get heard themselves.' },
]

export default function ProductLoop() {
  return (
    <LoopPage
      h1="Ship. Listen. Refine. Repeat."
      subhead="In-product feedback that adapts to every response. Themes back to the PM and engineering team before the next sprint starts."
      outerLoopSteps={['Build', 'Ship', 'Test', 'Feedback', 'Refine']}
      gapHeadline="In-product surveys collect 2% and explain nothing"
      gapBody="Customer interviews take a month and capture five users. In-product surveys get 2% response and 1-line answers. Neither closes the loop fast enough to influence the next sprint. PrismScope embeds at the point of use and runs the conversation that surfaces the why."
      stakeholders={stakeholders}
      sampleRetro={{
        wentWell: 'Feature X adoption tracking with power users. Workflow Z resonated across new and tenured cohorts.',
        couldHaveBeenBetter: 'Empty-state confusion on first run. Settings drawer discovery is below 20%.',
        whatsNext: 'Replace the empty-state copy with an example case. Surface the settings drawer in the first-run tour.',
      }}
      calloutBlock={{
        kind: 'beta',
        headline: 'Put the loop where your users already are.',
        body: 'Embed PrismScope directly inside your product via iframe or URL link. Trigger feedback loops at decision points, friction states, and success moments. Themes flow back into your existing PrismScope workspace.',
        ctaText: BETA_CTA_TEXT,
        ctaHref: EMBED_BETA_HREF,
      }}
      trackingPrefix="product-loop"
      seoTitle="In-Product Feedback & Rapid User Research"
      seoDescription="Close the build-ship-test loop. In-product feedback that adapts to every response and lands themes with your PM and engineers before the next sprint."
      seoPath="/feedback-loops/product"
    />
  )
}
